import api from './api';

export default {
  getContents(search) {
    return new Promise((resolve, reject) => {
      const where = [['metable_type', '=', 'App\\Models\\Content']];
      if (search !== null) {
        where.push(['title', 'like', '%' + search + '%']);
      }
      api
        .get('meta-data', {
          orderBy: 'title,asc',
          params: {
            filters: {
              where
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getContent(id) {
    return new Promise((resolve, reject) => {
      const params = {
        where: [['metable_id', '=', id]]
      };
      api
        .get('meta-data', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
